import React from 'react';
import { motion } from 'framer-motion';
import logo from '../assets/logo1.png'; 

const Preloader = () => {
  return (
    <motion.div 
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-[#020617]"
      initial={{ opacity: 1 }}
      exit={{ opacity: 0, transition: { duration: 0.8, ease: "easeInOut" } }}
    >
      <div className="relative flex flex-col items-center">
        
        {/* Soft Background Glow */}
        <motion.div 
          className="absolute w-64 h-64 bg-indigo-500/10 rounded-full blur-[100px]"
          animate={{ scale: [1, 1.2, 1], opacity: [0.3, 0.5, 0.3] }}
          transition={{ duration: 3, repeat: Infinity }}
        />

        {/* Logo Animation */}
        <motion.img 
          src={logo} 
          alt="Vidulaka Logo" 
          className="w-32 md:w-40 h-auto relative z-10 mb-8"
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        />

        {/* Brand Name - කලින් තිබුණ විදිහටම (Indigo Style) */}
        <div className="text-center z-10">
          <motion.h1 
            className="text-white text-4xl md:text-5xl font-black tracking-widest uppercase"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.3, duration: 0.6 }}
          >
            VIDULAKA <span className="text-indigo-500">MATALE</span>
          </motion.h1>

          {/* Powered By Smart Class - Yellow Theme (සයිට් එකේ විදිහටම) */}
          <motion.div
            className="mt-6 flex flex-col items-center"
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.7, duration: 0.5 }}
          >
            <p className="text-white/40 text-[10px] font-bold uppercase tracking-[0.4em] mb-2">
              Powered by
            </p>
            
            {/* Smart Class Tag Style */}
            <div className="bg-yellow-400 px-4 py-1 rounded-sm shadow-lg shadow-yellow-400/10">
               <span className="text-[#020617] font-black text-xs md:text-sm tracking-[0.2em] uppercase">
                 SMART CLASS
               </span>
            </div>
          </motion.div>
        </div>

        {/* Loading Progress Bar */}
        <div className="mt-14 w-48 h-[2px] bg-white/5 relative overflow-hidden rounded-full">
          <motion.div 
            className="absolute h-full bg-indigo-500"
            initial={{ left: "-100%" }}
            animate={{ left: "100%" }}
            transition={{ duration: 1.8, repeat: Infinity, ease: "linear" }}
          />
        </div>

      </div>
    </motion.div>
  );
};

export default Preloader;